const KEY = "ruangchat_widget_cfg";

export const WIDGET_COLORS = [
  { name: "Indigo", value: "#6366f1" },
  { name: "Emerald", value: "#10b981" },
  { name: "Rose", value: "#f43f5e" },
  { name: "Amber", value: "#f59e0b" },
  { name: "Cyan", value: "#06b6d4" },
  { name: "Violet", value: "#8b5cf6" },
];

const DEFAULTS = { color: "#6366f1", position: "right" };

export const getWidgetConfig = () => {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
  } catch {
    return { ...DEFAULTS };
  }
};

export const saveWidgetConfig = (cfg) => {
  localStorage.setItem(KEY, JSON.stringify(cfg));
};
